import axios from "axios";
import { db } from "./offlineDB";
import { env } from "../constants/env";

export const syncOfflineAccreditations = async (token) => {
  if (!navigator.onLine) return;

  const all = await db.offlineAccreditations.toArray();

  for (const acc of all) {
    const { id, offline, timestamp, lastSynced } = acc;

    const localIsNewer =
      !lastSynced || new Date(timestamp) > new Date(lastSynced);

    if (!offline && !localIsNewer) continue;

    try {
      const payload = {
        name: acc.name,
        labId: acc.labId,
        section: acc.section,
        auditorId: acc.auditorId,
        answers: acc.answers,
        metadata: acc.metadata,
        status: acc.status,
      };

      // Always POST, backend will handle create/update
      const res = await axios.post(`${env.kataApiUrl}/api/accreditation`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const serverData = res.data.accreditation;

      // Remove temp record if offline
      if (id.startsWith("offline-")) {
        await db.offlineAccreditations.delete(id);
      }

      // Save server version locally
      await db.offlineAccreditations.put({
        id: serverData._id,
        ...serverData,
        offline: false,
        lastSynced: new Date().toISOString(),
        timestamp: Date.now(),
      });

      console.log("[SYNC] Accreditation synced:", acc.section, acc.labId);
    } catch (err) {
      console.error("[SYNC] Accreditation failed:", acc.id, err.message);
    }
  }
};